module.exports = __webpack_public_path__ + "img/index-top-logo.5bce3b63.svg";